import { render, staticRenderFns } from "./ListPathwayEnrollments.vue?vue&type=template&id=08d33f70&"
import script from "./ListPathwayEnrollments.vue?vue&type=script&lang=js&"
export * from "./ListPathwayEnrollments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports